import { ListItemButton, ListItemButtonProps } from '@mui/material';

const ListItemButtonWrapper: React.FC<ListItemButtonProps> = (props) => <ListItemButton {...props} />;

export default ListItemButtonWrapper;
